import { useCreateEntityApi } from '@/common/api/createEntityApi';
import type { OutboundDeliveryResponse } from './common/outboundDeliveryResponse';
import { useOutboundDeliveryStore } from '../stores/outboundDeliveryStore';
import type { DeliveryStatus } from 'shared/deliveries/domain/deliveryStatus';

export interface CreateOutboundDelivery {
  name: string;
  note: string | null;
  status: DeliveryStatus;
  customer: string | null;
  customerReference: string | null;
  plannedStartUtc: string | null;
  plannedFinishUtc: string | null;
  rows: CreateOutboundDeliveryRow[];
}

export interface CreateOutboundDeliveryRow {
  productId: string;
  storageAreaId: string | null;
  weight: number | null;
  volume: number | null;
  note: string | null;
}

export interface CreateOutboundDeliveryResponse {
  ok: true;
  delivery: OutboundDeliveryResponse;
}

export function useCreateOutboundDeliveryApi() {
  const store = useOutboundDeliveryStore();

  return useCreateEntityApi<CreateOutboundDelivery, CreateOutboundDeliveryResponse>({
    url: 'delivery/outbound',
    translate: (t) => t.outboundDelivery.actions.create,
    async processOk(response) {
      const json = (await response.json()) as OutboundDeliveryResponse;
      store.add(json);
      return {
        ok: true,
        delivery: json,
      };
    },
  });
}
